import { render, staticRenderFns } from "./ProfileDocs.vue?vue&type=template&id=2e73f448&"
import script from "./ProfileDocs.vue?vue&type=script&lang=js&"
export * from "./ProfileDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports